// @flow
import React from 'react';

type Props = {
  job: {
    state: string,
    continueOnFailure: boolean
  }
};

export default class WaiterJobSummary extends React.PureComponent<Props> {
  render() {
    const continueOnFailureNode = this.props.job.continueOnFailure && (
      <div className="dark-gray">
        Build will continue even if previous stage fails
      </div>
    );

    return (
      <div
        className={`build-details-pipeline-waiter-job --state-${this.props.job.state}`}
      >
        <span>
          <i className="fa fa-chevron-down" />
        </span>
        {continueOnFailureNode}
      </div>
    );
  }
}
